import { z } from 'zod';
import { SUPPORTED_RECEIVE_CURRENCIES, SUPPORTED_SEND_CURRENCIES } from '../constants/index.js';

const Currency = z.enum([...SUPPORTED_SEND_CURRENCIES, ...SUPPORTED_RECEIVE_CURRENCIES]);
const Amount = z.number().positive().finite().max(1_000_000);

export const ExchangeRateInputSchema = z
  .object({
    from_currency: Currency,
    to_currency: Currency,
    rate: z.number().positive().finite(),
    effective_from: z.string().datetime().optional(),
    effective_to: z.string().datetime().nullable().optional(),
    is_active: z.boolean().default(true),
  })
  .refine((v) => v.from_currency !== v.to_currency, {
    message: 'rate.corridor.same',
    path: ['to_currency'],
  });
export type ExchangeRateInput = z.infer<typeof ExchangeRateInputSchema>;

export const FeeTierInputSchema = z
  .object({
    from_currency: Currency,
    to_currency: Currency,
    min_amount: z.number().min(0),
    max_amount: z.number().positive().nullable().optional(),
    fee_fixed: z.number().min(0).default(0),
    fee_percent: z.number().min(0).max(0.999).default(0),
    is_active: z.boolean().default(true),
  })
  .refine((v) => v.from_currency !== v.to_currency, {
    message: 'fee.corridor.same',
    path: ['to_currency'],
  })
  .refine((v) => v.max_amount == null || v.max_amount > v.min_amount, {
    message: 'fee.range.invalid',
    path: ['max_amount'],
  });
export type FeeTierInput = z.infer<typeof FeeTierInputSchema>;

export const RateQuoteSchema = z.object({
  from_currency: z.enum(SUPPORTED_SEND_CURRENCIES),
  to_currency: z.enum(SUPPORTED_RECEIVE_CURRENCIES),
  amount: Amount,
});
export type RateQuoteInput = z.infer<typeof RateQuoteSchema>;
